import store from '@/store'
export default [
  {
    path: '/disciplinary-sub-types',
    name: 'disciplinary-sub-type',
    meta: { requiresAuth: true },
    component: () => import('@/pages/disciplinary-sub-type/index.vue')
  },
  {
    path: '/disciplinary-sub-types/:id',
    name: 'disciplinary-sub-type-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/disciplinary-sub-type/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await store.dispatch(
        'disciplinarySubType/find',
        to.params.id
      )
      let { ...resource } = response.data
      to.params.editData = resource
      next()
    }
  }
]
